// src/store/slices/alertSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  severity: 'info', // success | error | warning | info
  title: '',
  message: '',
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const { severity, title, message } = action.payload;
      state.open = true;
      state.severity = severity;
      state.title = title;
      state.message = message;
    },
    closeAlert: (state) => {
      state.open = false;
    },
  },
});

export const { showAlert, closeAlert } = alertSlice.actions;
export default alertSlice.reducer;
